<template>
  <bootstrap-modal
    :modal-title="`請確認${title}`"
    :is-open="isModalOpen"
    :size="size"
    @modal:close="cancel"
    @modal:okay="agree"
  >
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-10 mb-4">
          <p class="text-center">
            {{ message }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <slot />
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>
<script>
import { mapActions } from 'vuex'
import BootstrapModal from '~bootstrap/Modal'
export default {
  name: 'ConfirmationModal',
  components: {
    BootstrapModal
  },
  props: {
    isModalOpen: Boolean,
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  watch: {
    isModalOpen (value) {
      this.toggleModal(value)
    }
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    cancel () {
      this.$emit('modal:close')
    },
    agree () {
      this.$emit('modal:okay')
    }
  }
}
</script>
